"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert_json_object = exports.assert_json_array = exports.assert_json_non_null = exports.assert_json_null = exports.assert_json_boolean = exports.assert_json_number = exports.assert_json_string = void 0;
const inspect_1 = require("./inspect");
function assert_json_string(data) {
    if (typeof data === "string")
        return data;
    throw new Error(`Expecting data to be string instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_string = assert_json_string;
function assert_json_number(data) {
    if (typeof data === "number")
        return data;
    throw new Error(`Expecting data to be number instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_number = assert_json_number;
function assert_json_boolean(data) {
    if (typeof data === "boolean")
        return data;
    throw new Error(`Expecting data to be boolean instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_boolean = assert_json_boolean;
function assert_json_null(data) {
    if (data === null)
        return data;
    throw new Error(`Expecting data to be null instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_null = assert_json_null;
function assert_json_non_null(data) {
    if (data !== null)
        return data;
    throw new Error(`Expecting data to be not null.\n`);
}
exports.assert_json_non_null = assert_json_non_null;
function assert_json_array(data) {
    if (data instanceof Array)
        return data;
    throw new Error(`Expecting data to be array instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_array = assert_json_array;
function assert_json_object(data) {
    if (data === null)
        throw new Error(`Expecting data to be object instead of null: ${(0, inspect_1.inspect)(data)}.\n`);
    if (data instanceof Array)
        throw new Error(`Expecting data to be object instead of array: ${(0, inspect_1.inspect)(data)}.\n`);
    if (typeof data === "object")
        return data;
    throw new Error(`Expecting data to be object instead of: ${(0, inspect_1.inspect)(data)}.\n`);
}
exports.assert_json_object = assert_json_object;
//# sourceMappingURL=json.js.map